$(document).on("click",".next-page" , function(){
    window.history.forward();
});